import EsameEcgEdit from "./components/EsameEcgEdit.vue";
import EsameEcgView from "./components/EsameEcgView.vue";
import EsameEcgList from "./components/EsameEcgList.vue";

export default {
    EsameEcgEdit,
    EsameEcgView,
    EsameEcgList,
};
